module.exports = __webpack_public_path__ + "static/media/qr-baby.2752be4a.png";